import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ediName } from "@/lib/api";

export const EDI_HELP = {
  850: "Purchase Order. Inbound from Group O: the authoritative replenishment demand signal for an xDock site. Outbound from EP: a raw material call-off.",
  940: "Warehouse Shipping Order. Generated automatically by EP for each Amazon order (SAP, Coupa or manual entry), telling the xDock what to pick and ship to the Amazon FC.",
  945: "Warehouse Shipping Advice. Group O confirms what actually shipped against a 940: pallets (SSCC), BOL, PRO and quantities.",
  861: "Receiving Advice. Group O confirms what it received at the xDock from an EP truckload, including any damaged quantity.",
  856: "Advance Ship Notice. Group O tells EP which raw material reels are on the way to the EP plant for a call-off.",
  997: "Functional Acknowledgement. Confirms an EDI file was received and passed syntax checks (planned).",
};

export const EdiTag = ({ code, prefix = "", className = "" }) => {
  if (!EDI_HELP[code]) return <span className={className}>{prefix}{code}</span>;
  return (
    <Tooltip delayDuration={150}>
      <TooltipTrigger asChild>
        <span tabIndex={0} data-testid={`edi-tag-${code}`} className={`inline-flex cursor-help items-center gap-1 decoration-dotted underline-offset-4 hover:underline ${className}`}>
          {prefix}{ediName(code)}
          <Info className="h-3 w-3 opacity-50" />
        </span>
      </TooltipTrigger>
      <TooltipContent data-testid={`edi-help-${code}`} className="max-w-xs border border-slate-700 bg-[#252A35] font-sans text-xs leading-relaxed text-slate-200">
        {EDI_HELP[code]}
      </TooltipContent>
    </Tooltip>
  );
};
